import { CommonModule } from '@angular/common';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { NavigationEnd, Router, RouterModule, ActivatedRoute } from '@angular/router';
import { I18nService } from '../../../services/i18n-service';
import { filter, takeUntil, Subject } from 'rxjs';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './header.html',
  styleUrl: './header.scss',
})
export class Header implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();
  selectedLanguage: 'en' | 'fr' | 'es' = 'en';

  constructor(public i18n: I18nService, private router: Router, private route: ActivatedRoute) { }

  ngOnInit(): void {
    // Check for lang query param and set language
    this.route.queryParams.subscribe(params => {
      const lang = params['lang'] as 'en' | 'fr' | 'es';
      if (lang && ['en', 'fr', 'es'].includes(lang)) {
        this.i18n.setLanguage(lang);
      }
    });

    // Initialize selectedLanguage from current I18nService language
    this.selectedLanguage = this.i18n.getCurrentLanguage();

    // Subscribe to language changes
    this.i18n.translations$
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.selectedLanguage = this.i18n.getCurrentLanguage();
      });

    this.router.events
      .pipe(
        filter(event => event instanceof NavigationEnd),
        takeUntil(this.destroy$)
      )
      .subscribe(() => {
        // Language selector now visible on all pages
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  isOpen = false;

  menuItems = [
    { label: 'My IB', internalName: 'header.myIB', link: 'https://ibo.my.site.com/ibportal/' },
    { label: 'IBIS', internalName: 'header.ibis', link: 'https://ibis.ibo.org/?language=ENGLISH' },
    { label: 'Students', internalName: 'header.students', link: 'https://candidates.ibo.org/' },
    { label: 'Store', internalName: 'header.store', link: 'https://www.follettibstore.com/main/home' },
    { label: 'Blogs', internalName: 'header.blogs', link: 'https://blogs.ibo.org/' },
    { label: 'Ask a Question', internalName: 'header.askQuestion', link: 'https://www.ibo.org/contact-the-ib/ask-a-question/' }
  ];

  changeLang(event: string) {
    const lang = event as 'en' | 'fr' | 'es';
    this.selectedLanguage = lang;
    this.i18n.setLanguage(lang);
    this.router.navigate([], { queryParams: { lang }, queryParamsHandling: 'merge' });
  }
}
